// Гейт авторизации для действий генерации.
//
// Инструменты открыты всем: фото можно загрузить, настройки поменять. Но кнопка
// запуска генерации у незалогиненного пользователя не запускает генерацию, а
// открывает модалку «Требуется авторизация» (см. components/AuthModal.js,
// смонтирована один раз в AppShell). Общаемся через window-событие 'openAuthModal'.

export const AUTH_MODAL_EVENT = 'openAuthModal';

// Пользователь считается авторизованным, если есть и токен, и данные пользователя
// (тот же критерий, что в SidebarMenu / ai-photo).
export const isAuthenticated = () => {
  if (typeof window === 'undefined') return false;
  try {
    return (
      !!localStorage.getItem('authToken') && !!localStorage.getItem('userData')
    );
  } catch (_) {
    return false;
  }
};

// Открыть модалку логина/регистрации, передав текущий URL для возврата после входа.
export const openAuthModal = () => {
  if (typeof window === 'undefined') return;
  const redirect = window.location.pathname + window.location.search;
  window.dispatchEvent(
    new CustomEvent(AUTH_MODAL_EVENT, { detail: { redirect } })
  );
};

// Обёртка для обработчиков генерации: true — можно продолжать, false — открыли
// модалку и обработчик должен прерваться (`if (!ensureAuth()) return;`).
export const ensureAuth = () => {
  if (isAuthenticated()) return true;
  openAuthModal();
  return false;
};
